import React, { FC } from 'react';

import { t } from 'state/intl/translations';
import { getDesignToken, spacing } from 'styles/constants';

import { MethodType, TextContainer } from './styled';

interface ICashMethod {
  isDisabled?: boolean;
  isRedesign?: boolean;
}

const CashMethod: FC<ICashMethod> = ({ isDisabled, isRedesign }) => {
  const textProps = isRedesign
    ? { variant: 'headerTwo', fontSize: 'lg', marginTop: spacing.$2 }
    : null;

  return (
    <TextContainer>
      <MethodType
        color={isDisabled ? getDesignToken('text-disabled') : getDesignToken('text-default')}
        {...textProps}
      >
        {t('cash')}
      </MethodType>
    </TextContainer>
  );
};

export default CashMethod;
